import Api from 'src/api/Base'

class GetAdminConfigMessages extends Api {
  requestUrl = `/api/adminConfig`
}

export default GetAdminConfigMessages
